import { createSelector } from 'reselect';
import { timestampToDateString } from '../firebase';

const getAlbums = (state) => (state && state.albums) || [];
const getFeatures = (state) => (state && state.features) || [];

// onst getArtistAlbums = (state) => (state.selectedArtist && state.selectedArtist.albums) || {};

const getArtistAlbums = (state) => {
	const albumSelectorArtist = state.firestore &&
	state.firestore.ordered &&
	state.firestore.ordered.albumSelectorArtist &&
	state.firestore.ordered.albumSelectorArtist.length &&
	state.firestore.ordered.albumSelectorArtist[0];

	return (albumSelectorArtist && albumSelectorArtist.albums) ? albumSelectorArtist.albums : {};
};

export const mapArtistAlbums = createSelector([getArtistAlbums], (albums) => {
	return Object.entries(albums).map(([key, value]) => {
		return value
	});
});

export const mapAlbumsToGridData = createSelector([getAlbums], (albums) => {
	return albums.map(album => {
		const reviewCount = album.scores && album.scores.length ? album.scores.length : 0;
		return {
			albumName: album.name,
			artist: album.artist.name,
			image: album.image,
			genres: album.genres && album.genres.join('/'),
			id: album.id,
			labels: album.labels && album.labels.join('/'),
			releaseDate: album.releaseDate && timestampToDateString(album.releaseDate),
			scores: reviewCount,
			actions: [{id: 'review', name: 'Add/Edit Review'}]
		}
	});
});

export const mapFeaturesToGridData = createSelector([getFeatures], (features) => {
	return features.map(feature => {
		return {
			name: feature.name,
			image: feature.image,
			type: feature.type.name,
			id: feature.id,
			publishDate: feature.publishDate && timestampToDateString(feature.publishDate)
		}
	});
});
